import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  justify-content: center;
  align-items: center;
`;

export const EmojiBlock = styled.p`
  font-weight: 400;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: -31px;
  white-space: nowrap;

  position: relative;
  left: -15px;
`;
